import { AppData, Lightning, Utils } from "@lightningjs/sdk";
import { Helper } from "../lib/helper";
import { AppSetup } from "../lib/app-setup";
import WebpTexture from "../ui-textures/wepp-texture";
import FallbackImage from "./fallback-image";

export default class WatchlistButton extends Lightning.Component {
    private _inQueue = false;
    private _action: string | undefined;

    static override _template() {
        return {
            w: 100,
            h: 100,
            collision: true,
            flex: { direction: "column", alignItems: "center" },
            Icon: {
                w: 85,
                h: 85,
                type: FallbackImage,
                imgSrc: '',
            },
            Label: {
                y: 12,
                alpha: 0,
                text: {
                    fontSize: 22,
                    textAlign: "center",
                    fontFace: Helper.getFontFamily("Black"),
                },
            },
        };
    }

    set action(v: string | undefined) {
        this._action = v;
    }

    set label(v: string | undefined) {
        this._updateLabel();
    }

    /** Reflects server / queue state: item is currently in the watchlist. */
    set isAdded(v: boolean) {
        this._inQueue = v;
        if (this.hasFocus()) {
            this._focus();
        } else {
            this._unfocus();
        }
        this._updateLabel();
    }

    get isAdded(): boolean {
        return this._inQueue;
    }

    private _updateLabel() {
        this.tag("Label").text.text = this._inQueue ? "Remove from Watchlist" : "Add to Watchlist";
    }

    override _init() {
        if (this.hasFocus()) {
            this._focus();
        } else {
            this._unfocus();
        }
        this._updateLabel();
    }

    override _focus() {
        const {appConfig} = AppData as AppSetup
        const ext = appConfig?.testWebp ? '.webp' : '.png'
        const src = this._inQueue ? `images/hover-watchlistRemoved${ext}` : `images/hover-watchlistAdd${ext}`;
        //this.tag('Icon').texture = Lightning.Tools.getSvgTexture(src, 85, 85);
        console.log('src - :', src)
        this.tag('Icon').patch({
                imgSrc: src
        })
        this.tag("Label").patch({ alpha: 1 });
        const { platform } = AppData as AppSetup
        platform?.textToSpeach(this._inQueue ? "Remove from Watchlist" : "Add to Watchlist")
    }

    override _unfocus() {
        const {appConfig} = AppData as AppSetup
        const ext = appConfig?.testWebp ? '.webp' : '.png'
        const src = this._inQueue ? `images/watchlistAdded${ext}` : `images/watchlistAdd${ext}`;
        //this.tag('Icon').texture = Lightning.Tools.getSvgTexture(src, 85, 85);
        this.tag('Icon').patch({
                imgSrc: src
        })
        this.tag("Label").patch({ alpha: 0 });
    }

    override _handleEnter() {
        if (this._action) {
            this.fireAncestors(this._action as any);
        }
        return true;
    }

    override _handleClick() {
        if (this._action) {
            this.fireAncestors("$onButtonClick" as any, this);
            this.fireAncestors(this._action as any);
        }
        return true;
    }
}
